export const formatNumber = (value: number, decimalPlaces = 2): string => {
  const maxDigitsNumber = parseFloat(value.toFixed(decimalPlaces));
  return maxDigitsNumber.toLocaleString('pt-BR');
};
